<template>
    <div class="t-documents">
        <div v-if="imageLoaded && imageLoaded.src" class="t-documents-viewer" id="t-viewer" @click="CloseViewer()">
            <span class="t-closeViewer _absolute" @click.stop="CloseViewer()">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M29 11L11 29M29 29L11 11" stroke="#F39049" stroke-width="4"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
            <div class="t-documents-viewer__container">
                <img :src="imageLoaded.src" @click.stop="" 
                    @mousedown.stop.prevent=""
                    v-touch:swipe.stop.prevent="SwipeImg()" 
                    >
            </div>
            <div class="t-documents-viewer__buttons" @click.stop="">
                <span class="t-closeViewer viewer-arrows" :class="{_disabled:imageLoaded.index == 0}"
                      @click.prevent="SetViewer(0)">
                    <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.00195 3.99992L13.0016 3.99992M1.00195 3.99992L5.00184 1M1.00195 3.99992L5.00184 6.99983"
                            stroke="#52A8F2"
                            stroke-width="2.00006" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="t-closeViewer viewer-arrows" :class="{_disabled:imageLoaded.index == items.length - 1}"
                      @click.prevent="SetViewer(1)">
                    <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.998 4.00008L1.99838 4.00008M13.998 4.00008L9.99816 7M13.998 4.00008L9.99816 1.00017"
                          stroke="#52A8F2"
                          stroke-width="2.00006" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div>
        </div>
        <div :class="{'t-work-area__cell':isProfile}">
            <h2>{{documentsText.title}}</h2>
            <div class="t-document-list">
                <div class="t-document-list__uploader" v-if="isProfile">
                    <div class="t-document-list__uploader__area"
                         :class="{_error: this.errors, _loading: upload_files.length}">
                        <div class="t-document-list__uploader__area__upload" v-if="upload_files.length">
                            <form class="t-documents-load">
                                <label class="t-btn t-btn_file t-btn_white" :class="{_error: this.errors}"
                                       @click.prevent="ClearUpload()">
                                    <span v-if="this.errors">
                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                        <path d="M29 11L11 29M29 29L11 11" stroke="#F39049" stroke-width="4"
                                              stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                    <span v-else>
                                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
<path d="M20.6996 3.59961H9.09961C8.54732 3.59961 8.09961 4.04732 8.09961 4.59961V31.3996C8.09961 31.9519 8.54733 32.3996 9.09961 32.3996H26.8996C27.4519 32.3996 27.8996 31.9519 27.8996 31.3996V10.7996M20.6996 3.59961V9.79961C20.6996 10.3519 21.1473 10.7996 21.6996 10.7996H27.8996M20.6996 3.59961L27.8996 10.7996"
      stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                                    </span>
                                </label>
                            </form>
                            <h4 v-if="this.errors">{{documentsText.tryAgain}}</h4>
                            <h4 v-else>{{documentsText.loading}}</h4>
                            <p v-if="this.errors">{{this.errors}}</p>
                            <cmp-doc-upload v-for="(doc, index) in upload_files"
                                            :key="'doc_upload_' + index"
                                            :data="doc"
                                            @cancelUpload="CancelUpload(index)" v-if="!errors"></cmp-doc-upload>
                        </div>
                        <div class="t-document-list__uploader__area__form" v-else>
                            <form class="t-documents-load">
                                <label class="t-btn t-btn_file t-btn_white">
                                    <input type="file" @change="LoadFile($event.target.files)">
                                    <span>
                                        <svg width="58" height="58"
                                             viewBox="0 0 58 58" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M29 16.2715V41.7273M41.7279 28.9994H16.2721" stroke="#52A8F2"
                                                  stroke-width="4" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </label>
                            </form>
                            <h4>{{documentsText.upload}}</h4>
                            <p>{{documentsText.you_may}}</p>
                        </div>
                    </div>
                </div>
                <div class="t-document-list__items" :class="{_full:!isProfile}">
                    <cmp-doc v-for="(doc, index) in items" :key="'doc_' + index" :data="doc"
                             :isProfile="isProfile" @ViewImage="ViewImage(doc, index)"></cmp-doc>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import vue2Dropzone from 'vue2-dropzone';

    import Pagination from './Pagination.vue';
    import Doc from './Doc.vue';
    import DocUpload from './DocUpload.vue';

    export default {
        props: ['pageText', 'isProfile'],
        data() {
            return {
                upload_files: [],
                errors: false,
                imageLoaded: {src: null, index: null},
            }
        },
        components: {
            'cmp-pagination': Pagination,
            'cmp-doc': Doc,
            'cmp-doc-upload': DocUpload,
            "cmp-dropzone": vue2Dropzone
        },
        computed: {
            ...mapGetters('staticText', ['fileArr', 'documentsText']),
            ...mapGetters('profile', ['documents']),
            ...mapGetters('user', ['user']),
            doc_count() {
                return this.declOfNum(this.documents._meta.totalCount, this.fileArr)
            },
            upload_count() {
                return this.declOfNum(this.upload_files.length, this.fileArr)
            },
            documents_list() {
                return this.isProfile ? this.documents.items : this.user.documents;
            },
            items() {
                if (!this.isProfile) {
                    return this.documents_list;
                }

                return this.documents_list.length > 8 ? this.documents_list.slice(0, 8) : this.documents_list;
            },
            dropzoneOptions() {
                return {
                    url: 'upload_doc',
                    thumbnailWidth: 150,
                    maxFilesize: 0.5,
                    headers: {"My-Awesome-Header": "header value"}
                };
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('profile', ['LoadDocuments']),
            SwipeImg(){
                return (direction) => {
                    if (direction == 'left'){
                        this.SetViewer(1);
                    } else if (direction == 'right')  {
                        this.SetViewer(0);
                    }
                }
            },
            LoadFile(files) {
                let _this = this;
                for (let i = 0; i < files.length; i++) {
                    let type = files[i].name.split('.')[1].replace('.', '') + ', ' + Math.floor(files[i].size / 1000) + ' КБ';

                    this.upload_files.push({
                        file: files[i],
                        name: files[i].name.split('.')[0],
                        type: type,
                        progress: 0,
                        error: false
                    });

                    let fd = new FormData();
                    fd.append('file', files[i]);

                    _this.$http.post('upload_doc', fd, {
                        progress(e) {
                            if (e.lengthComputable) {
                                _this.upload_files[i].progress = (e.loaded / e.total) * 100;
                            }
                        }
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                this.LoadDocuments(this.$route.query.page);
                                this.upload_files = [];
                            } else {
                                _this.upload_files[i].error = true;
                                _this.errors = data.errors.file[i];
                            }
                        })
                        .catch(error => {
                            _this.upload_files[i].error = true;
                            _this.errors = error;
                        })
                }
            },
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            CancelUpload(index) {
                if (this.upload_files[index].error)
                    this.upload_files.splice(index, 1)
            },
            ClearUpload() {
                this.errors = false;
                this.upload_files = [];
            },
            Load(pageText) {
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            },
            ViewImage(document, index) {
                this.imageLoaded = {
                    src: document.url,
                    index: index
                }
            },
            CloseViewer() {
                this.imageLoaded = {src: null, index: null};
            },
            SetViewer(type) {
                let index = this.imageLoaded.index;
                if ((type === 0 && index > 0) || (type === 1 && index < this.items.length - 1)) {
                    let newIndex = type === 1 ? index + 1 : index - 1;
                    this.ViewImage(this.items[newIndex], newIndex);
                }
            },
            keyPress(e){
                e = e || window.event;
                if (e.keyCode == '37') {
                    // left arrow
                    this.SetViewer(0)
                }
                else if (e.keyCode == '39') {
                    // right arrow
                    this.SetViewer(1)
                }
            }
        },
        created() {
            document.addEventListener('keydown', this.keyPress)
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.keyPress)
        },
    }
</script>

<style lang="sass">
    .t-documents-viewer
        position: fixed
        background: rgba(0, 49, 92, 0.9)
        width: 100%
        height: 100%
        top: 0
        left: 0
        z-index: 9999
        &__buttons
            width: 100px
            text-align: center
            margin: 0 auto
            display: flex
            flex-direction: row
            justify-content: space-between
        .t-closeViewer
            justify-content: center
            width: 56px
            height: 56px
            cursor: pointer
            background: #FFFFFF
            box-shadow: 0 24px 32px rgba(0, 108, 202, 0.1)
            border-radius: 50%
            padding: 8px 0 0 8px
            &.viewer-arrows
                display: block
                padding: 6px 0 0 0
                width: 40px
                height: 40px
                &._disabled
                    cursor: default
                    opacity: 0.8
                    svg
                        path
                            stroke: $grey
            svg
                path
                    stroke: $blue
            &._absolute
                position: absolute
                right: 10px
                top: 10px
        &__container
            width: 760px
            height: 760px
            margin: 50px auto 10px auto
            text-align: center
            max-height: calc(90vh - 70px)
            display: flex
            img
                z-index: 9999
                margin: 0 auto!important
                width: auto!important
                height: auto!important
                object-fit: contain
                -webkit-user-select: none
                -moz-user-select: none
                cursor: grab
                &::active
                    cursor: grabbing
    .t-documents
        margin-top: 30px
        h2
            color: $blue
            margin: 0 0 42px
            span
                display: block
                font-size: 16px
                margin-top: 16px
        .t-documents-load
            width: auto
            margin: 80px auto 0 auto
            .t-btn_file
                width: 56px
                height: 56px
                border-radius: 50%
                padding: 0px
                &._error
                    color: #e96900
                span
                    font-size: 40px
                    path
                        fill: transparent
                svg
                    margin: 0 auto !important
        .t-document-list
            margin: 0 0 50px
            display: flex
            flex-direction: row
            &__uploader
                margin: 30px 50px 0 0
                display: flex
                max-width: 250px
                padding-bottom: 45px
                &__area
                    cursor: pointer
                    @extend %substrate_transparent
                    height: 100%
                    border: 3px dashed $blue
                    text-align: center
                    &._error
                        border-color: #e96900
                        .t-btn_file
                            padding: 8px 0 0 0 !important
                            &:hover
                                background: white
                    &._loading
                        padding: 0 20px
                        h4
                            width: 100%
                            margin-top: 20px
                        .t-btn_file
                            padding: 10px 0 0 2px
                            &:hover
                                background: white
                    &:hover
                        background: white
                        box-shadow: $shadow
                    h4
                        color: $blue
                        font-size: 19px
                        width: 50%
                        margin: 0 auto
                        line-height: 1.3
                        margin-bottom: 10px
                    p
                        color: $grey
                        font-size: 14px
                        padding: 10px
            &__items
                max-width: 550px
                display: flex
                align-items: stretch
                justify-content: flex-start
                flex-wrap: wrap
                margin: 30px -64px 0 0
                &._full
                    max-width: 100%
        @media(max-width: 1024px)
            .t-document-list
                margin: 0 auto !important
                flex-direction: column
                &__uploader
                    margin: 0 auto !important
                    max-width: 100% !important
                &__items
                    margin: 30px 0 0 0
                    max-width: 100% !important
                    justify-content: center !important
        @media(max-width: 769px)
            .t-documents-viewer
                &__container
                    width: auto
                    height: auto
                    img
                        width: 100%!important
                        height: auto!important
                        padding: 20px
</style>


// WEBPACK FOOTER //
// src/vue_components/Documents.vue